module.exports = __webpack_public_path__ + "img/error1.4c350f00.png";